export const CrossIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.82861 4.17188L4.17176 9.82873" stroke="#858DBD" strokeWidth="2" strokeLinecap="round" />
    <path d="M4.17139 4.17188L9.82824 9.82873" stroke="#858DBD" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
